// src/IT/pages/ITMyRequests.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { listMyITRequests } from "../../api/ITapi";
import StatusPill from "../components/StatusPill";

export default function ITMyRequests() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const load = async () => {
    try {
      const data = await listMyITRequests();
      setRows(data || []);
    } catch (e) {
      alert(e.message);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    const qq = q.trim().toLowerCase();
    return (rows || []).filter((r) => {
      if (status && r.status !== status) return false;
      if (!qq) return true;
      return (
        (r.title || "").toLowerCase().includes(qq) ||
        (r.description || "").toLowerCase().includes(qq) ||
        (r.request_type || "").toLowerCase().includes(qq)
      );
    });
  }, [rows, q, status]);

  return (
    <div className="it-page">
      <div className="it-card">
        <div className="it-row">
          <div className="it-card-title">My Requests</div>
          <button className="it-btn-sm" onClick={load}>Refresh</button>
        </div>

        <div className="it-grid2">
          <label className="it-field">
            <div className="it-label">Search</div>
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search title/desc/type..." />
          </label>
          <label className="it-field">
            <div className="it-label">Status</div>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">All</option>
              <option value="PENDING_MANAGER">PENDING_MANAGER</option>
              <option value="APPROVED">APPROVED</option>
              <option value="REJECTED">REJECTED</option>
              <option value="CANCELLED">CANCELLED</option>
            </select>
          </label>
        </div>

        <table className="it-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Type</th>
              <th>Title</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id}>
                <td>#{r.id}</td>
                <td>{r.request_type}</td>
                <td>
                  <Link className="it-link" to={`/it/req/${r.id}`}>{r.title}</Link>
                </td>
                <td><StatusPill status={r.status} /></td>
                <td>{new Date(r.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {!filtered.length && (
              <tr>
                <td colSpan="5" className="it-muted">No requests found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
